var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { Carousel } from '../../../ts/components/Carousel';
export class Project extends Component {
    constructor() {
        super('Project', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.carousel').on('click', (event, carousel) => {
                const isNext = event.pageX > $(window).width() / 2;
                if (isNext) {
                    Carousel.next(carousel.attr('id'));
                }
                else {
                    Carousel.prev(carousel.attr('id'));
                }
                setTimeout(() => {
                    this.spy();
                }, 600);
            });
            $(window).on('scroll', () => {
                this.spy();
            });
            this.spy();
            this.success();
        });
    }
    spy() {
        $('.project-caption').each((caption, index) => {
            const project = caption.parents('.project');
            let isInvisible = false;
            if ($(window).width() >= 768) {
                isInvisible = /* caption.viewportPosition().y + caption.height() > $(window).height() || */ caption.viewportPosition().y < $('h1').viewportPosition().y + $('h1 a').height();
            }
            else {
                isInvisible = project.viewportPosition().y < project.height() / -2 /*|| project.viewportPosition().y > project.height() / 2*/;
            }
            /*if (index === $('.project-caption').length - 1 && project.viewportPosition().y <= $(window).height() / 2 + 40) {
              $('.project-caption').addClass('opacity-0');
              caption.removeClass('opacity-0');
            } else*/ if (isInvisible) {
                caption.addClass('opacity-0');
            }
            else {
                caption.removeClass('opacity-0');
            }
        });
    }
}
